import React, { useEffect, useRef,useContext } from 'react'
import { Container } from 'reactstrap'
import Toggle from '../Toggle/Toggle'
import {themeContext} from '../../Context'


import './Header.css'
const Header = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    const headerRef = useRef(null)
    const menuRef = useRef(null)
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
                headerRef.current.classList.add('header_shrink')
            } else {
                headerRef.current.classList.remove('header_shrink')
            }
        })
        return () => {
            window.removeEventListener('scroll', null)
        }
    }, []);
    const menuToggle = () => menuRef.current.classList.toggle('menu_active')
    const headerClick = (e) => {
        e.preventDefault()
        const targetAttr = e.target.getAttribute('href')
        const location = document.querySelector(targetAttr).offsetTop;
        window.scroll({
            left: 0,
            top: location - 70
        })
    }
    const navLinks = [
        {
            display: 'Home',
            url: '#home'
        },
        {
            display: 'About',
            url: '#about'
        },
        {
            display: 'Services',
            url: '#services'
        },
        {
            display: 'Experience',
            url:'#experience'
        },
        {
            display: 'Protfolio',
            url: '#portfolio'
        },{
            display: 'Certifications',
            url: '#certificates'
        },
        {
            display: 'Contact',
            url: '#contact'
        }
    ]
    return <header className='header' ref={headerRef} style={{color:darkMode? '#FFFFFF' : '#000000' }}>
        <Container>
            <div className="navigation d-flex align-items-center justify-content-between">
                <div><h5 style={{fontSize:'1.3rem', fontWeight:'bold', textDecoration:'overline', color:darkMode?'var(--primary-color)':'#00509d'}}> SHASHI KANTH PORTFOLIO </h5></div>
                <div className="toggle"><Toggle/></div>

                <div className={`nav_menu ${darkMode?'nav_menu_dark':'nav_menu_light'}`} ref={menuRef} onClick={menuToggle}>
                    <ul className="nav_list">
                        {
                            navLinks.map((item, index) => <li className="nav_item" key={index} >
                                <a onClick={headerClick} href={item.url}>{item.display}</a>
                            </li>)
                        }
                    </ul>
                </div>
                <div className="nav_right d-flex align-items-center gap-4">
                    <span className={`mobile_menu ${darkMode?'mobile_menu_dark':'mobile_menu_light'}`}><i className="ri-menu-5-line" onClick={menuToggle}></i></span>
                </div>
            </div>

        </Container>
    </header>
}

export default Header